import { compose, defaultProps } from 'recompose'
import { connect } from 'react-redux'

import { Loading } from 'modules/ui'
import { withLoading, withTheme } from 'modules/util'
import { Question } from '../../selectors'
import questionTheme from './theme.scss'

function mapStateToProps(state) {
  return {
    question: Question.current(state),
    loaded: Question.loaded(state)
  }
}

export default compose(
  connect(mapStateToProps),
  defaultProps({ question: {} }),
  withTheme(questionTheme),
  withLoading(Loading)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Question/enhancers.js